import { useCreateProjectIndication } from 'lib/hooks/project/useCreateProjectIndication';
import React from 'react';
import styled from 'styled-components';
import IndicationCard, { IIndicationCard } from './IndicationCard';

interface ProjectIndicationShadeProps {
  indicationShadeList: (IIndicationCard | undefined)[] | undefined;
  materialShade: number;
  onShadeChange: (index: number) => void;
}

const ProjectIndicationShade = ({
  indicationShadeList,
  materialShade,
  onShadeChange,
}: ProjectIndicationShadeProps) => {
  return (
    <StyledProjectIndicationShade>
      {indicationShadeList?.map((material?: IIndicationCard) => {
        if (!material) return;

        return (
          <IndicationCard
            key={material.key}
            selectedKey={materialShade}
            cardItem={material}
            onClick={onShadeChange}
          />
        );
      })}
    </StyledProjectIndicationShade>
  );
};

const StyledProjectIndicationShade = styled.div`
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
`;

export default ProjectIndicationShade;
